import { render, staticRenderFns } from "./ModalBackofficeAgendarSala.vue?vue&type=template&id=4aa83d56&scoped=true"
import script from "./ModalBackofficeAgendarSala.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeAgendarSala.vue?vue&type=script&lang=ts"
import style0 from "./ModalBackofficeAgendarSala.vue?vue&type=style&index=0&id=4aa83d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa83d56",
  null
  
)

export default component.exports